<template>
  <div id="userInfo">
    <div>
      <el-tabs type="border-card">
        <el-tab-pane label="基本信息">
          <div class="f1">
            <div @click="uploadDialog=true" class="img-p">
              <el-image class="img" :src="heading" fit="cover"></el-image>
            </div>
            <div>
              <el-form :label-position="labelPosition" label-width="120px" :model="form">
                <el-form-item label="姓名：" class="row">
                  <el-input style="width:270px" v-model="form.nickname"></el-input>
                  <span class="goToBind">*</span>
                </el-form-item>
                <el-form-item label="单位：" class="row">
                  <el-input style="width:270px" v-model="form.organization"></el-input>
                  <span class="goToBind">*</span>
                </el-form-item>
                <el-form-item label="地址：" class="row">
                  <el-input style="width:270px" v-model="form.address"></el-input>
                  <span class="goToBind">*</span>
                </el-form-item>
                <el-form-item label="身份：" class="row">
                  <template>
                    <el-select v-model="form.identity" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.label"
                        :label="item.label"
                        :value="item.label"
                      ></el-option>
                    </el-select>
                  </template>
                  <span class="goToBind">*</span>
                  <div style="font-size:12px">当身份为学生时必须填写导师姓名和导师联系方式</div>
                </el-form-item>
                <el-form-item v-if="form.identity == '学生'" label="导师姓名：" class="row">
                  <el-input v-model="form.teacher"></el-input>
                </el-form-item>
                <el-form-item v-if="form.identity == '学生'" label="导师联系方式：" class="row">
                  <el-input v-model="form.teacher_phone"></el-input>
                </el-form-item>
                <el-form-item label="性别：">
                  <el-radio-group v-model="form.sex">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="2">女</el-radio>
                    <el-radio label="0">保密</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="生日：">
                  <el-date-picker
                    value-format="timestamp"
                    v-model="form.birthday"
                    type="date"
                    placeholder="选择日期"
                    style="width:200px;"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="邮箱：" class="row">
                  <el-input v-model="form.email" disabled style="width:200px;"></el-input>
                  <router-link to="/user/bindEmail" class="goToBind">修改邮箱</router-link>
                </el-form-item>
                <el-form-item label="手机号：" class="row">
                  <el-input v-model="form.bind_mobile" disabled style="width:200px;"></el-input>
                  <router-link to="/user/bindMobile" class="goToBind">修改手机号</router-link>
                </el-form-item>
                <el-form-item label="主账户：" class="row">
                  <el-input placeholder="填写主账户登陆账号" disabled v-model="form.p_user"></el-input>
                </el-form-item>
              </el-form>
              <div class="submit-p">
                <el-button type="primary" class="submit" @click="save">保存</el-button>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="绑定主账户" v-if="ishost != 1 ">
          <div class="f1">
            <div style="padding-top:30px;height:900px">
              <el-form :label-position="labelPosition" label-width="120px">
                <el-form-item label="主账户：" class="row">
                  <el-input style="width:400px" v-model="account" placeholder="请填写主账户登陆账号"></el-input>
                </el-form-item>
              </el-form>
              <div class="submit-p" style="margin-top:60px">
                <el-button
                  type="primary"
                  class="submit"
                  style="width:300px;height:50px"
                  @click="submitAccount()"
                >保存</el-button>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="兴趣分类">
          <div class="f2">
            <el-row :gutter="20">
              <el-col :span="6" v-for="(item,index) of arr" :key="index">
                <div class="i-p" @click="choose(index)" :class="item.state?'active':''">
                  <div class="i">{{item.label}}</div>
                </div>
              </el-col>
            </el-row>
            <div style="text-align:center">
              <el-button type="primary" class="submit" @click="submit2()">保存</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="提示" :visible.sync="uploadDialog" width="30%">
      <div align="center">
        <el-upload
          :action="serve + '/personal/headImg'"
          class="avatar-uploader"
          :show-file-list="false"
          :http-request="upload"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="lv3Text" style="padding:10px 0;">只能上传jpg或png文件，且不超过5mb</div>
      <div class="error" v-if="error.length>0">{{error}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      heading: '',
      account: '',
      options: [
        {
          label: '教授'
        },
        {
          label: '学生'
        }
        ,
        {
          label: '管家或工作人员'
        }
        ,
        {
          label: '公司客户'
        }
      ],
      value: '',
      src1: '',
      error: '',
      labelPosition: 'right',
      form: {},
      arr: [],
      selected: '',
      uploadDialog: false,
      imageUrl: '',
      mobile: this.$cookies.get('user'),
      token: this.$cookies.get('token'),
      header: {
        mobile: this.mobile,
        token: this.token
      },
      ishost: null
    }
  },
  activated() {
    this.$store.state.user_location = '个人信息'
    this.openHost()
  },
  created() {
    this.initData()
    this.openHost()
  },
  methods: {
    alert_success(message) {
      this.$message({
        message: message,
        type: 'success',
        offset: 200
      })
    },
    alert_error(message) {
      this.$message({
        message: message,
        type: 'error',
        offset: 200
      })
    },
    openHost() {
      this.axios
        .get(this.serve + '/personal/is_open_host', {
          params: {
            mobile: this.mobile,
            token: this.token
          }
        })
        .then(res => {
          this.ishost = res.data
        })
    },
    submitAccount() {
      this.axios
        .get(this.serve + '/personal/apply_children', {
          params: {
            mobile: this.mobile,
            token: this.token,
            f_user: this.account
          }
        })
        .then(res => {
          if (res.data.status == 'success') {
            this.alert_success('绑定成功,请等待主账户审核')
          } else if (res.data.status == 'error') {
            this.alert_error(res.data.msg)
          }
        })
    },
    save() {
      var json = this.form
      json.mobile = this.mobile
      json.token = this.token
      this.axios
        .get(this.serve + '/personal/save_personal_info', {
          params: json
        })
        .then(res => {
          if (res.data.status == 'success') {
            this.$confirm(
              '恭喜您保存个人信息获得60积分!',
              '完善信息奖励',
              {
                distinguishCancelAndClose: true,
                confirmButtonText: '获取更多积分',
                cancelButtonText: '留在本页',
                showClose:false
              }
            )
              .then(() => {
                this.$router.push("/user/score/1")
              })
              .catch(action => {
               
              })
          } else if (res.data.msg) {
            this.alert_error(res.data.msg)
          }
        })
    },
    upload(prarm) {
      if (prarm.file.size > 5242880) {
        this.error = '图片大小不能超过5mb'
        return
      } else {
        this.error = ''
      }
      if (
        prarm.file.type != 'image/jpeg' &&
        prarm.file.type != 'image/jpg' &&
        prarm.file.type != 'image/png'
      ) {
        this.error = '图片格式不正确'
        return
      } else {
        this.error = ''
      }
      var imgObj = prarm.file
      var reader = new FileReader()
      var form = new FormData()
      form.append('head', imgObj)
      form.append('mobile', this.mobile)
      form.append('token', this.token)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      var that = this
      this.axios
        .post(this.serve + '/personal/headImg', form, config)
        .then(function(res) {
          if ((res.data.status = 'success')) {
            reader.readAsDataURL(imgObj)
            reader.onload = function(e) {
              var result = e.target.result
              that.imageUrl = result
            }
            that.initData()
          }
        })
    },
    submit2() {
      var json = {
        mobile: this.mobile,
        token: this.token,
        ids: this.selected
      }
      this.axios
        .get(this.serve + '/personal/save_like_class', {
          params: json
        })
        .then(res => {
          if (res.data.status == 'success') {
            this.alert_success('已保存')
          }
        })
    },
    choose(key) {
      if (this.arr[key].state) {
        this.$set(this.arr[key], 'state', false)
      } else {
        this.$set(this.arr[key], 'state', true)
      }
      this.selected = ''
      for (var item of this.arr) {
        if (item.state) {
          this.selected = this.selected + ',' + item.id
        }
      }
    },
    initData() {
      this.axios
        .get(this.serve + '/personal/personal_info', {
          params: {
            mobile: this.mobile,
            token: this.token
          }
        })
        .then(res => {
          this.heading = res.data.data.headImg
          this.form = res.data.data
        })

      this.axios
        .get(this.serve + '/personal/get_like_class', {
          params: {
            mobile: this.mobile,
            token: this.token
          }
        })
        .then(res => {
          var results = res.data.data.results
          let selected = res.data.data.like_class
          for (var item of results) {
            var obj = {}
            if (selected.indexOf(item.id) > -1) {
              this.selected = this.selected + ',' + item.id
              obj = { label: item.cate_name, state: true, id: item.id }
            } else {
              obj = { label: item.cate_name, state: false, id: item.id }
            }
            this.arr.push(obj)
          }
        })
    }
  }
}
</script>
<style lang="scss">
#userInfo {
  .error {
    color: red;
  }
  .img {
    cursor: pointer;
    border: 1px solid #ddd;
    padding: 5px;
    width: 150px;
    height: 150px;
  }
  .submit {
    width: 150px;
    margin: 20px 0;
    margin-bottom: 40px;
  }
  .goToBind {
    margin-left: 35px;
    color: #e2211c;
  }
  .fa-check {
    position: relative;
    top: 25px;
    left: -14px;
    color: #fff;
    height: 10px;
  }
  .f2 {
    padding: 40px;
  }
  .i-p {
    margin-bottom: 20px;
    border: 2px solid #ddd;
    color: #666;
    text-align: center;
    padding: 15px 0;
  }
  .i {
    display: inline-block;
    cursor: pointer;
  }
  .i-p:hover,
  .i-p.active {
    border: 2px solid #e2211c;
    color: #e2211c;
  }
  .i-icon {
    width: 0;
    height: 0;
    border-bottom: 25px solid red;
    border-left: 25px solid transparent;
    height: 20px;
    margin-top: -45px;
    margin-left: 178px;
    position: absolute;
    top: 15px;
  }
  .f1 {
    .submit-p {
      text-align: center;
    }
    .row {
      padding-right: 110px;
    }
  }
  .img {
    display: block;
    margin: 50px auto;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    border-top: 3px solid #f5f7fa;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    border-top: 3px solid #e2211c;
  }
  .f1 {
    width: 550px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
}
</style>